import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  public parse(value: string): NgbDateStruct {
    if (value) {
      if (value.includes('-')) {
        const dateParts: string[] = value.trim().split('-');
        if (dateParts.length === 1 && dateParts[0]) {
          return { day: null, month: null, year: +dateParts[0] };
        } else if (dateParts.length === 2 && dateParts[0] && dateParts[1]) {
          return { day: null, month: +dateParts[1], year: +dateParts[0] };
        } else if (dateParts.length === 3 && dateParts[0] && dateParts[1] && dateParts[2]) {
          return { day: +dateParts[2], month: +dateParts[1], year: +dateParts[0] };
        }
      } else {
        const dateParts: string[] = value.trim().split('/');
        if (dateParts.length === 1 && dateParts[0]) {
          return { day: null, month: +dateParts[0], year: null };
        } else if (dateParts.length === 2 && dateParts[0] && dateParts[1]) {
          return { day: +dateParts[1], month: +dateParts[0], year: null };
        } else if (dateParts.length === 3 && dateParts[0] && dateParts[1] && dateParts[2]) {
          return { day: +dateParts[1], month: +dateParts[0], year: +dateParts[2] };
        }
      }
    }
    return null;
  }

  public format(date: NgbDateStruct): string {
    return date ? `${date.month ? ('0' + date.month).slice(-2) : ''}/${date.day ? ('0' + date.day).slice(-2) : ''}/${date.year}` : '';
  }
}
